export const ExperimentNames = {
    UseWarmupData: 'specs.events.ui.UseWarmupData',
    ImageSettings: 'specs.events.ui.ImageSettings',
    DisableMembersSiteCreation: 'specs.events.ui.DisableMembersSiteCreation',
    ShowCouponInputInPaymentStep: 'specs.events.ui.ShowCouponInputInPaymentStep',
    SelectEventsManually: 'specs.events.ui.SelectEventsManually',
    UseInfraCurrencyFormatter: 'specs.events.ui.UseInfraCurrencyFormatter',
    RsvpButtonSettings: 'specs.events.ui.RsvpButtonSettings',
    SplitRegButtonDefaults: 'specs.events.ui.SplitRegButtonDefaults',
    PriceOptionsBM: 'specs.events.ui.PriceOptionsBM',
    TicketPreview: 'specs.events.ui.TicketPreview',
    ReservationWithoutWixFeeEnabled: 'specs.events.ReservationWithoutWixFeeEnabled',
    viewerNoCss: 'specs.events.ui.viewerNoCss',
    CancelReservationInDetailsPage: 'specs.events.ui.CancelReservationInDetailsPage',
};
//# sourceMappingURL=experiments.js.map